import React from "react";
import { useSelector } from "react-redux";

import { Container, Row, Col } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { staticData } from "managers/staticDataManager";
import { oldDocumentDownload } from "views/callApi";
import { DEFAULT_LIST_PAGESIZE } from "config";
import { useNavigateUrl } from "managers/utilManager";

const OldDocumentsTable = (params) => {
  const state = useSelector((state) => state);

  const headerStyle = { backgroundColor: "var(--brand-color)", color: "white" };

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      params.setFilterData({
        ...params.filterData,
        page: 1,
        sortField: sortField,
        sortOrder: sortOrder,
      });
    }
    if (type === "pagination") {
      params.setFilterData({ ...params.filterData, page: page });
    }
  };

  const navigateUrl = useNavigateUrl();

  const issuerCellClickHandler = (e, cell, rowIndex, row) => {
    if (row?.issuerId) {
      navigateUrl(`/old-documents/${row.issuerId}`);
    }
  };

  const layoutCellClickHandler = (e, cell, rowIndex, row) => {
    oldDocumentDownload(state, row, params.setIsBusy, params.alertRef);
  };

  const cellMouseEnterHandler = (e) => {
    e.target.style.textDecoration = "underline";
    e.target.style.cursor = "pointer";
  };

  const cellMouseLeaveHandler = (e) => {
    e.target.style.textDecoration = "";
    e.target.style.cursor = "default";
  };

  const columns = [
    {
      dataField: "issuer",
      text: staticData.loadTerms(useSelector, "VW_FILTER_ISSUER"),
      sort: true,
      events: {
        onClick: issuerCellClickHandler,
        onMouseEnter: cellMouseEnterHandler,
        onMouseLeave: cellMouseLeaveHandler,
      },
      headerStyle: headerStyle,
    },
    {
      dataField: "fileName",
      text: staticData.loadTerms(useSelector, "VW_FILTER_LAYOUT"),
      sort: true,
      events: {
        onClick: layoutCellClickHandler,
        onMouseEnter: cellMouseEnterHandler,
        onMouseLeave: cellMouseLeaveHandler,
      },
      headerStyle: headerStyle,
    },
    {
      dataField: "fileSize",
      text: staticData.loadTerms(useSelector, "VW_FILTER_FILESIZE"),
      sort: true,
      headerStyle: headerStyle,
    },
  ];

  return (
    <Container>
      <Row>
        <Col sm="12" md="12" className="mt-5">
          <div className="public-table-pagionator-wrapper">
            <BootstrapTable
              hover
              bootstrap4
              keyField="oldDocumentId"
              columns={columns}
              data={params?.documentsData}
              filter={filterFactory()}
              bordered={false}
              onTableChange={handleTableChange}
              pagination={paginationFactory({
                sizePerPage: DEFAULT_LIST_PAGESIZE,
                hideSizePerPage: true,
              })}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default OldDocumentsTable;
